
      import { urlLegend } from './assets/js/configuracion.js';
      document.querySelectorAll('img[data-layer]').forEach(img => {
        const layer = img.getAttribute('data-layer');
        img.src = `${urlLegend}${layer}`;
      });
    